import { cn } from "@/lib/utils";

const STATUS_STYLES = {
  draft: "bg-slate-100 text-slate-700 border-slate-200",
  prepared: "bg-blue-50 text-blue-700 border-blue-200",
  sent: "bg-indigo-50 text-indigo-700 border-indigo-200",
  viewed: "bg-sky-50 text-sky-700 border-sky-200",
  partially_signed: "bg-amber-50 text-amber-700 border-amber-200",
  completed: "bg-emerald-50 text-emerald-700 border-emerald-200",
  declined: "bg-red-50 text-red-700 border-red-200",
  expired: "bg-slate-100 text-slate-500 border-slate-200",
  cancelled: "bg-slate-100 text-slate-500 border-slate-200",
  pending: "bg-slate-100 text-slate-600 border-slate-200",
  signed: "bg-emerald-50 text-emerald-700 border-emerald-200",
};

const LABELS = {
  partially_signed: "Partially signed",
};

export default function StatusBadge({ status, className }) {
  if (!status) return null;
  const style = STATUS_STYLES[status] || STATUS_STYLES.draft;
  const label = LABELS[status] || status.replace(/_/g, " ");
  return (
    <span
      data-testid={`status-badge-${status}`}
      className={cn(
        "inline-flex items-center gap-1.5 px-2.5 py-0.5 rounded-md text-xs font-medium border capitalize",
        style,
        className,
      )}
    >
      <span className="h-1.5 w-1.5 rounded-full bg-current opacity-70" />
      {label}
    </span>
  );
}
